import {PortExposureChunk} from "../../chunks/types/PortExposureChunk";
import {getOwnPortNameFromPortExposureBodyChunk} from "./getOwnPortNameFromPortExposureBodyChunk";

export function getOwnPortNameFromPortExposureChunk(
  portExposureChunk: PortExposureChunk
): string {
  const {
    captures: {
      1: portExposureBodyChunk
    }
  } = portExposureChunk;
  return getOwnPortNameFromPortExposureBodyChunk(portExposureBodyChunk);
}
